import { v4 as uuidv4 } from "uuid";
import {
    generateNewChoice,
    questionsDefault,
    generateDefaultPage,
    generateSurveyTemplate,
} from "../../surveys";

const pages = [
    {
        ...generateDefaultPage(),
        questions: [
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "How easy was it for you to [Insert Task/Action Here]?",
                choices: [
                    generateNewChoice("Much easier than I expected"),
                    generateNewChoice("A bit easier than I expected"),
                    generateNewChoice("About as easy as I expected"),
                    generateNewChoice("A bit more difficult than I expected"),
                    generateNewChoice("Much more difficult than I expected"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["openText"],
                headline: "What would have made it easier?",
                longAnswer: true,
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "Overall, how satisfied are you with us?",
                choices: [
                    generateNewChoice("Very satisfied"),
                    generateNewChoice("Somewhat satisfied"),
                    generateNewChoice("Neither satisfied nor dissatisfied"),
                    generateNewChoice("Somewhat dissatisfied"),
                    generateNewChoice("Very dissatisfied"),
                ],
            },
        ],
    },
];

export const customerEffortScoreSurveyTemplate = generateSurveyTemplate({
    name: "Customer Effort Score (CES)",
    pages,
});
